import { useState } from "react";

interface UpdateEvent {
  id: number;
  hostname: string;
  state: string;
  reason: string | null;
  created_at: string;
}

export function AgentActivityTab() {
  const [events] = useState<UpdateEvent[]>([]);
  // TODO: Wire to actual API when update-events admin endpoint is added
  return (
    <div className="space-y-4 p-4">
      <h3 className="text-lg font-semibold">Agent Activity</h3>
      <p className="text-sm text-gray-500">Recent update events across your fleet.</p>
      {events.length === 0 ? (
        <p className="text-sm text-gray-400">No update events recorded yet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead><tr className="border-b text-left">
            <th className="py-2 pr-4">Time</th>
            <th className="py-2 pr-4">Host</th>
            <th className="py-2 pr-4">State</th>
            <th className="py-2 pr-4">Reason</th>
          </tr></thead>
          <tbody>{events.map((e) => (
            <tr key={e.id} className="border-b">
              <td className="py-2 pr-4 text-xs">{new Date(e.created_at).toLocaleString()}</td>
              <td className="py-2 pr-4 font-mono text-xs">{e.hostname}</td>
              <td className="py-2 pr-4"><span className="px-2 py-0.5 rounded text-xs bg-gray-100">{e.state}</span></td>
              <td className="py-2 pr-4 text-xs text-gray-500">{e.reason || "—"}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  );
}
